export default __webpack_public_path__ + "static/media/transfer.b4916f6c.svg";